export default "__VITE_ASSET__DdfwhMJv__"